import React, { useEffect, useState } from "react";
import { Card, Button, TextField, Box, palette } from "@material-ui/core";
import { useStyles } from "../../styles/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  LoadProfileAction,
  LoadUsersListAction,
  UserDeleteAction,
  UpdateUserAction,
} from "../../redux/actions/ProfileActions";
import SimpleMenu from "../../components/layouts/Navigation";
import { DataGrid } from "@material-ui/data-grid";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SearchBar from "material-ui-search-bar";
import { useHistory, Link } from "react-router-dom";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ArrowBackRounded from "@material-ui/icons/ArrowBackRounded";
import logo from "../../logo.png";
import { RegisterAction } from "../../redux/actions/AuthActions";
import * as ActionTypes from "../../redux/ActionTypes";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import AuthorizationErrorComponent from '../AuthorizationErrorComponent';
import ValidationErrorComponent from '../ValidationErrorComponent';

import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);
export default function UserListing(props) {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const usersListResponse = useSelector((state) => state.userDetails.usersList);
  const users = useSelector((state) => state.userDetails.users);
  const roles = useSelector((state) => state.userDetails.roles);
  const [searched, setSearched] = useState("");
  const [rows, setRows] = useState([]);
  const [rolesConfig, setRolesConfig] = useState([]);
  const [roleSetting, setRoleSetting] = useState("");
  const [runStatus, setRunStatus] = useState(false);
  const [restrictedStatus, setRestrictedStatus] = useState(false);
  const [restrictedResponse, setRestrictedResponse] = useState(""); 
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [emailFlag, setEmailFlag] = useState(false);
  const [passwordFlag, setPasswordFlag] = useState(false);
  const [errorFlag, setErrorFlag] = useState(false)
  const [phoneError, setPhoneError] = useState(false);
  const [phoneErrorStatus, setPhoneErrorStatus] = useState(false);
  const [deleteData, setDeleteData] = useState("");
  const [deleteOpen,setDeleteOpen]=useState(false);
  const [refresh,setRefresh] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const [fields, setState] = useState({
    name: "",
    email: "",
    password: "",
    first_name:"",
    middle_name: "",
    last_name:"",
    contact_no:"",
    password_confirmation: "",
    id: null,
    changeStatus: false,
    createStatus:false,
    role_users_id: null,
    date_of_birth: "",
    gender: "male",
  });

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    //{ field: "name", headerName: "Name", width: 130 },
    { field: "first_name", headerName: "First Name", width: 130 },
    //{ field: "middle_name", headerName: "Role", width: 130 },
    { field: "last_name", headerName: "Last Name", width: 130 },
    { field: "contact_no", headerName: "Contact Name", width: 130 },
    { field: "email", headerName: "Email", width: 130 },
   // { field: "role_users_id", headerName: "Role", width: 130},
    
    //{ field: "gender", headerName: "Gender", width: 130,},
    { field: "is_active", headerName: "Status", width: 130 },
    {
      field: "actions",
      headerName: "Actions",
      width: 130,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              textAlign: "center",
              paddingLeft: "15px",
              paddingRight: "15px",
            }}
          >
            <DeleteIcon
              color="secondary"
              onClick={(event) => {
                deleteUser(event, cellValues);
              }}
            />{" "}
            <EditIcon
              color="primary"
              onClick={(event) => {
                editUser(event, cellValues);
              }}
            />{" "}
          </div>
        );
      },
    },
  ];
 
  const editUser = (event, param) => {
   
    setState({
      ...fields,
      first_name:param.row.first_name,
      middle_name: param.row.middle_name,
      last_name:param.row.last_name,
      contact_no:param.row.contact_no,
      email: param.row.email,
      name: param.row.name,
      id: param.row.id,
      changeStatus: false,
      fieldStatus: false, //control status of messages
      renderStatus: false, // cross render
      createStatus:false,
      role_users_id: param.row.role_users_id,
      gender: param.row.gender,
      date_of_birth: param.row.date_of_birth,
      is_active: param.row.is_active==1?"Active":"Inactive"
    });
    dispatch({ type: ActionTypes.FREE_USER_STATE, usersListResponse });
   
    setOpen(true);
  };
  const callingRoles = (item) =>{
    rolesConfig.map((role)=>{
      if (role.role_users_id == item.row.role_users_id){
        setRoleSetting(role.name);
      }
     })
     return roleSetting;
          
  }
  const addUser = (event) => {
    setState({
      ...fields,
      name: "",
      email: "",
      password: "",
      first_name: "",
      last_name: "",
      middle_name: "",
      contact_no: "",
      password_confirmation: "",
      id: null,
      changeStatus: false,
      fieldStatus: false, //control status of messages
      renderStatus: false, // cross render
      createStatus:true,
      role_users_id:null,
      date_of_birth: "",
      gender: "male",
      is_active: 1
    });
    dispatch({ type: ActionTypes.FREE_USER_STATE, usersListResponse });

    setOpen(true);
  };
  const deleteUser = (event, param) => {
    event.stopPropagation();
    setDeleteOpen(true);
    setDeleteData(param.row);
  };
  const deleteUserConfirm = ()=>{
    setDeleteOpen(false);
    dispatch(UserDeleteAction(deleteData, history, setRefresh));
  }
  const requestSearch = (searchedVal) => {
    const filteredRows = users.filter((row) => {
      return row.name.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setRows(filteredRows);
  };
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    dispatch({ type: ActionTypes.FREE_USER_STATE, usersListResponse });
    setState({
      ...fields,
      name: "",
      email: "",
      password: "",
      first_name:"",
      last_name:"",
      middle_name: "",
      contact_no:"",
      password_confirmation: "",
      id: null,
      changeStatus: false,
      fieldStatus: false,
      renderStatus:true,
      role_users_id:"",
      is_active:0
    });
    setOpen(false);
  };
  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  /*Edit User Functionalities Section */

  const handleFieldChange = (e) => {
   
    if (e.target.value == ""){
      setState({
        ...fields, changeStatus: false,
        fieldStatus: false,
        [e.target.id]: e.target.value,
      })
    }else{
      setState({
        ...fields, changeStatus: true,
        fieldStatus: false,
        [e.target.id]: e.target.value,
      })
      setEmailFlag(false);
      if (e.target.id == "email") {
        let regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (!e.target.value.match(regex)) {
          setEmailFlag(true);
          setState({
            ...fields, changeStatus: false,
            fieldStatus: false,
            [e.target.id]: e.target.value,
          })

        }
      }
      if (e.target.id == "password_confirmation" && fields.password_confirmation == fields.password_confirmation){
        setPasswordMatch(true);
      }
    

  }
    
  };
  const handleFieldChangeSelect = (e) =>{
    const { name, value } = e.target;
    setState({
      ...fields, changeStatus: true,
      fieldStatus: false,
      [name]: value
    });
  }
  const  handleFieldChangePhone = (value) => {
    if(fields['contact_no']!=value){
     
      setState({
        ...fields,changeStatus: true,
        fieldStatus: false,
        'contact_no':value,
    })
  }
}


  const handleFieldChangeRadio = (e) => {
    setState({
      ...fields, changeStatus: true,
      fieldStatus: false,
      [e.target.name]: e.target.value,
    })

  }
  const checkPasswordMatch = (password, password_confirmation) => {
    return password !== password_confirmation ? true : false;
  };

  const UpdateUser = (e) => {
   
    e.preventDefault();
    if (!fields.changeStatus){
      return false;
    }
    setState({
      ...fields, changeStatus: false, fieldStatus: false
    });


    const passwordMatch = checkPasswordMatch(
      fields.password,
      fields.password_confirmation
    );
    if (passwordMatch === true) {
      setPasswordMatch(false);
      return;
    }
    
    
  
   
    dispatch(UpdateUserAction(fields, setRestrictedResponse,
      setRestrictedStatus, setRows, setRolesConfig, setRunStatus, setState));
    setRows(users);
   
  };

  const handleDeleteClose = () => {
    
    setDeleteOpen(false);
  }
  const showPasswordControl = (e) => {
    setShowPassword(!showPassword);
  }
  /*End of Edit User Functionalities Section */
  useEffect(() => {
    let abortController;
    abortController = new AbortController();
    let signal = abortController.signal;
    dispatch(LoadUsersListAction(setRestrictedResponse, setRestrictedStatus, setRows, setRolesConfig, signal));
   

    

    return () => {
      setRolesConfig([])
      setRows([])
      abortController.abort();
    };
  }, [fields.renderStatus || restrictedStatus || refresh]); 

  return (
    <>
      <div className={classes.root}>
        {restrictedStatus &&
          <> <Grid container className={classes.bodyWrapper}>
            <Grid item xs={12} style={{ height: "100vh" }}> <AuthorizationErrorComponent error={restrictedResponse.message} />

            </Grid>
          </Grid>
          </>
        }
        {!restrictedStatus &&
        <Grid container className={classes.bodyWrapper}>
          <Grid item xs={2}>
            <Paper className={classes.paper}>
            </Paper>
          </Grid>

          <Grid item xs={12} md={10} className={classes.rightSideContent} style={{marginTop: "25px" }}>
            <Grid item xs={9}>
                <Grid container>
                  <Grid item xs={3} className={classes.searchBox} style={{ paddingTop: "10px", marginBottom: "10px" }}>
                <SearchBar
                  value={searched}
                  onChange={(searchVal) => requestSearch(searchVal)}
                  onCancelSearch={() => cancelSearch()}
                  />
                </Grid>  <Grid item xs={3} >
                 <Button
                    
                      autoFocus onClick={(event) => {
                        addUser(event);
                      }} className={[classes.customButton, classes.addButton].join(" ")}
                      orientation="vertical"
                      aria-label="vertical contained button group"
                      variant="contained"
                      color="primary"
                      style={{ clear: "both"}}
                  >Add User</Button>
                </Grid>
                </Grid>
              <div className={classes.MuiDataGrid_windowContainer}>
                {users.length !== 0 ? (
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={5}
                    checkboxSelection
                    disableSelectionOnClick
                  />
                ) : (
                  <div className={classes.beforeLoad}>
                    Displaying Users List...
                  </div>
                )}
              </div>
            </Grid>
            <div>
              <Dialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth
                maxWidth="lg"
              >
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                  <b
                    className={classes.primary}
                    style={{ textAlign: "center" }}
                  >
                      {!fields.createStatus?" Edit User":"Add User"}
                  </b>
                  
                </DialogTitle>
                <DialogContent dividers>
                 
                  <form >
                    <Grid container item xs={12}>
                        {usersListResponse.success == false &&
                          usersListResponse.updatedUser != "" &&
                          fields.fieldStatus == true ? (
                            <Grid item xs={12}  className={classes.customFail}>

                              <ValidationErrorComponent error={usersListResponse.message} />
                            </Grid>
                        ) : usersListResponse.success == true &&
                          usersListResponse.updatedUser &&
                          fields.fieldStatus == true ? (
                              <Grid item xs={12}  className={classes.customSuccess}>
                            {usersListResponse.message}
                              </Grid>
                        ) : (
                          ""
                        )}
                        <Grid item xs={6} variant="outlined">
                        <TextField
                          type="text"
                          className={classes.fullWidth}
                          required
                          margin="normal"
                          variant="outlined"
                          label="First Name"
                          id="first_name"
                          value={fields.first_name}
                          onChange={handleFieldChange}
                        />
                          {fields.first_name == "" && <><br/> <span style={{color:"red"}}> First name must not be empty.</span></>}
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          type="text"
                          className={classes.fullWidth}
                          required
                          margin="normal"
                          variant="outlined"
                          label="Last Name"
                          id="last_name"
                          value={fields.last_name}
                          onChange={handleFieldChange}
                        />
                          {fields.last_name == "" && <><br /> <span style={{ color: "red" }}> Last name must not be empty.</span></>}
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          type="text"
                          className={classes.fullWidth}
                          required
                          margin="normal"
                          variant="outlined"
                          label="Username"
                          id="name"
                          value={fields.name}
                          onChange={handleFieldChange}
                        />
                          {fields.name == "" && <><br /> <span style={{ color: "red" }}> Username must not be empty.</span></>}
                      </Grid>
                        <Grid item xs={6}>
                          <TextField
                            type="text"
                            className={classes.fullWidth}
                            required
                            margin="normal"
                            variant="outlined"
                            label="Middle Name"
                            id="middle_name"
                            value={fields.middle_name}
                            onChange={handleFieldChange}
                          />
                        </Grid>

                      <Grid item xs={6}>
                        
                        <TextField
                          type="email"
                          className={classes.fullWidth}
                          required
                          margin="normal"
                          variant="outlined"
                          label="Email"
                          id="email"
                          value={fields.email}
                          onChange={handleFieldChange}
                        />
                          {fields.email == "" && <><br /> <span style={{ color: "red" }}> Email must not be empty.</span></>}
                          {emailFlag && <><br /> <span style={{ color: "red" }}> Fill up valid email like abd@gmail.com .</span></>}
                      </Grid>
                      <Grid  item xs={6}>
                          <PhoneInput
                            margin="normal"
                            country="np"
                            placeholder="9812345768"
                            name='contact_no'
                            specialLabel={'Phone Number'}
                            containerStyle={{
                              marginTop: "16px",
                              marginBottom: "8px",
                            }}

                            required

                            inputStyle={{ width: "auto", verticleAlign: "middle" }}
                            defaultErrorMessage="You must have 10 digit phone number starts with 98 or 97"

                            onlyCountries={['np']}
                            value={fields.contact_no}
                            onChange={(value, country, e, formattedValue) => handleFieldChangePhone(value, country, e, formattedValue)}
                            disableDropdown
                            disableCountryCode
                            inputProps={{
                              required: true,
                              autoFocus: true
                            }}
                            isValid={(value, country) => {
                              if (value.length == 0) {
                                
                                return true;
                              }
                              var reg = new RegExp('^9((7|8))[0-9]{8}$', 'i');
                              
                              if (!reg.test(value)) {
                                return false;
                              }
                              if (value.length == 10) {
                                return true;
                              } else {
                                return false;
                              }
                            }}
                          />
                          {fields.contact_no == "" && <><br /> <span style={{ color: "red" }}> Phone must not be empty.</span></>}
                      </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormControl variant="outlined" className={classes.formControl}>
                            <div>


                              <TextField
                                id="date_of_birth"
                                name="date_of_birth"
                                type="date"
                                margin="normal"
                                required
                                variant="outlined"
                                label="Date of Birth"
                                value={fields.date_of_birth}
                                onChange={handleFieldChange}
                                inputlabelprops={{
                                  shrink: false,
                                }}
                                focused
                              />
                            </div>
                            {fields.date_of_birth == "" && <><br /> <span style={{ color: "red" }}> Date of birth must not be empty.</span></>}
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} style={{ marginTop: "20px" }}>
                          <FormControl variant="outlined" className={classes.formControl}>
                            <FormLabel>Gender*</FormLabel>
                            <RadioGroup
                              required
                              name="gender"
                              id="gender"
                              value={fields.gender}
                              onChange={handleFieldChangeRadio}
                              row
                            >
                              <FormControlLabel
                                required
                                key="male"
                                value="male"
                                control={<Radio size="small" />}
                                label="Male"
                                checked={fields.gender == "male" ? true : false}
                              />
                              <FormControlLabel
                                key="female"
                                value="female"
                                control={<Radio size="small" />}
                                label="Female"
                                checked={fields.gender == "female" ? true : false}
                              />
                              <FormControlLabel
                                key="other"
                                value="other"
                                control={<Radio size="small" />}
                                label="Other"
                                checked={fields.gender == "other" ? true : false}
                              />
                            </RadioGroup>
                          </FormControl>

                        </Grid>
                        <Grid item xs={6}>
                         

                        
                        <FormControl variant="outlined" >
                          <InputLabel>Roles</InputLabel>

                          <Select
                            name="role_users_id"
                            id="role_users_id"
                            label="Roles"
                            value={fields.role_users_id??0}
                            variant="outlined"
                            onChange={handleFieldChangeSelect}
                           
                          >
                            <MenuItem key={0} value={0}>
                              Select Type
                            </MenuItem>

                            {rolesConfig.map((item) => {
                              return (<MenuItem key={item.id} value={item.id}>
                                {
                                  item.name
                                }
                              </MenuItem>)
                            }


                            )}

                          </Select>
                        </FormControl>
                        </Grid>
                        {!fields.createStatus &&  
                        <Grid item xs={12}>
                          <Button onClick={showPasswordControl} className={[classes.customButton].join(" ")}
                            orientation="vertical"
                            aria-label="vertical contained button group"
                            variant="contained"
                            color="primary"
                            style={{ clear: "both" }}>
                            {showPassword ? "Hide Password" : "Show Password"}
                          </Button>
                        </Grid>
                        }
                        {(showPassword || fields.createStatus) &&
                     
                      <Grid item xs={6}>
                        <TextField
                          className={classes.fullWidth}
                          label="Password"
                          type="password"
                          margin="normal"
                          variant="outlined"
                          id="password"
                          value={fields.password}
                          onChange={handleFieldChange}
                        />
                      </Grid>
                        } 
                        {(showPassword || fields.createStatus) &&
                      <Grid item xs={6}>
                        <TextField
                          className={classes.fullWidth}
                          label="Confirm Password"
                          type="password"
                          margin="normal"
                          variant="outlined"
                          id="password_confirmation"
                          value={fields.password_confirmation}
                          onChange={handleFieldChange}
                        />
                          {!passwordMatch && <><br /> <span style={{ color: "red" }}> Passwords must be matched.</span></>}
                        </Grid>
                       
                        }
                        <Grid item xs={6}>
                          <FormControl>
                            <FormLabel>User Status</FormLabel>
                            <RadioGroup
                              name="is_active"
                              id="is_active"
                              value={fields.is_active}
                              onChange={handleFieldChangeRadio}
                              row
                            >
                              <FormControlLabel
                                key="Active"
                                value="Active"
                                control={<Radio size="small" />}
                                label="Active"
                                variant="outlined"
                                checked={(fields.is_active == "Active" || fields.is_active == 1) ? true : false}
                              />
                              <FormControlLabel
                                key="Inactive"
                                value="Inactive"
                                control={<Radio size="small" />}
                                label="Inactive"
                                variant="outlined"
                                checked={(fields.is_active == "Inactive" || fields.is_active == 0 )? true : false}
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                    </Grid>
                  </form>
                </DialogContent>
                <DialogActions>
                     <Button autoFocus onClick={UpdateUser}  className={[classes.customButton].join(" ")}
                          orientation="vertical"
                          aria-label="vertical contained button group"
                          variant="contained"
                          color="primary"
                          style={{ clear: "both" }}>
                    Save changes
                  </Button>
                </DialogActions>
              </Dialog>

                {/* Assingnment */}

                <Dialog
                  onClose={handleDeleteClose}
                  aria-labelledby="customized-dialog-title"
                  open={deleteOpen}
                  fullWidth
                  maxWidth="lg"
                >
                  <DialogTitle id="customized-dialog-title" onClose={handleDeleteClose}>
                    <b
                      className={classes.primary}
                      style={{ textAlign: "center" }}
                    >
                      Confirmation of application Delete
                    </b>
                  </DialogTitle>
                  <DialogContent dividers>
                  
                    <form >
                      <Grid container item xs={12}>
                        <Typography variant="h6" component="div" gutterBottom style={{ color: "#0d0d0d", position: "relative" }}>
                          Are you sure you want to delete it?
                        </Typography>


                      </Grid>
                    </form>
                  </DialogContent>
                  <DialogActions>
                    <Button autoFocus onClick={deleteUserConfirm} className={[classes.customButton].join(" ")}
                      orientation="vertical"
                      aria-label="vertical contained button group"
                      variant="contained"
                      color="primary"
                      style={{ clear: "both" }}>
                      Yes
                    </Button>
                    <Button autoFocus onClick={handleDeleteClose} className={[classes.customButton].join(" ")}
                      orientation="vertical"
                      aria-label="vertical contained button group"
                      variant="contained"
                      color="primary"
                      style={{ clear: "both" }}>
                      No
                    </Button>
                    
                  </DialogActions>
                </Dialog>
            </div>
          </Grid>
        </Grid>
        }
      </div>
    </>
  );
}
